<template>
  <div>
    <vuestic-modal :show.sync="bankAccountShow"
                    ref="bankAccountModal"
                    :okText="'modal.confirm2' | translate"
                    style="height: 100%;width:60vw;"
                    :okClass="'btn btn-primary btn-micro'"
                    :cancelClass="'btn btn-secondary btn-micro'"
                    :cancelText="'modal.cancel2' | translate"
                    alignModal=""
                    class="change-email-show"
                    :noButtons="isView" >
      <div slot="title">{{ isView ? $t('view') : $t('finance.addBankAccount') }}</div>
      <p v-if="!isView">
        <small class="text-danger">{{ $t("finance.pleaseFillInTheInformationForYourWithdrawalAccount") }}</small><br />
        <small class="text-danger">{{ $t("finance.pleaseMakeSureThatAllDataProvidedIsCorrect") }}</small>
      </p>
      <div>
        <form class="bank-account" v-if="isFormShow">
          <fieldset :disabled="isView">
            <h3>{{ $t("finance.accountInfo") }}</h3>
            <div class="va-row">
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                      :class="{'has-error': errors.has('account_number'), 'valid': isFormFieldValid('account_number')}">
                  <div class="input-group">
                    <input name="account_number"
                            data-vv-as="Account Number"
                            v-model="bankAccountBean.account_number"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            oninput="value=value.slice(0, 34)" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" :class="{'required-item': !isView}" for="account_number">Account Number：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('account_number')"
                            class="help text-danger">{{ errors.first('account_number') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                    :class="{'has-error': currencyStatus, 'valid': currencyStatus}">
                  <div class="select-group" :class="{'required-item': !isView, 'dropdown-arrow': isView}" id="currencySelect">
                    <vuestic-kyc-select name="currency"
                                        data-vv-as="Currency"
                                        v-validate="'required'"
                                        required
                                        :label="$t('t.currency') + '：'"
                                        v-model="bankAccountBean.currency"
                                        option-key="label"
                                        :options="currencyOption"
                                        ref="currencyRefs"
                                        @input="value => { fieldChange(value, 'currencyRefs', 'currencyStatus') }"
                                        :clearable="false" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="currencyStatus"
                          class="help text-danger">{{ errors.first('currency') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                      :class="{'has-error': errors.has('account_name'), 'valid': isFormFieldValid('account_name')}">
                  <div class="input-group">
                    <input name="account_name"
                            data-vv-as="Account Name"
                            v-model="bankAccountBean.account_name"
                            autocomplete="off"
                            v-validate="'required'"
                            required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" :class="{'required-item': !isView}" for="account_name">Account Name：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('account_name')"
                            class="help text-danger">{{ errors.first('account_name') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                      :class="{'has-error': errors.has('bank_name'), 'valid': isFormFieldValid('bank_name')}">
                  <div class="input-group">
                    <input name="bank_name"
                            data-vv-as="Bank Name"
                            v-model="bankAccountBean.bank_name"
                            autocomplete="off"
                            v-validate="'required'"
                            required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" :class="{'required-item': !isView}" for="bank_name">Bank Name：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('bank_name')"
                            class="help text-danger">{{ errors.first('bank_name') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                    :class="{'has-error': countryStatus, 'valid': countryStatus}">
                  <div class="select-group" :class="{'required-item': !isView, 'dropdown-arrow': isView}" id="countrySelect">
                    <vuestic-kyc-select name="country"
                                        data-vv-as="Bank Country"
                                        v-validate="'required'"
                                        required
                                        :label="$t('finance.bankCountry') + '：'"
                                        v-model="bankAccountBean.country"
                                        option-key="label"
                                        :options="countryOption"
                                        ref="countryRefs"
                                        @input="value => { fieldChange(value, 'countryRefs', 'countryStatus') }"
                                        :clearable="false" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="countryStatus"
                          class="help text-danger">{{errors.first('country')}}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right">
                  <div class="input-group">
                    <input
                      name="branch"
                      data-vv-as="Branch"
                      v-model="bankAccountBean.branch"
                      autocomplete="off"
                    />
                    <label class="control-label" for="branch">Branch：</label>
                    <i class="bar"></i>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                      :class="{'has-error': errors.has('swift_code'), 'valid': isFormFieldValid('swift_code')}">
                  <div class="input-group">
                    <input name="swift_code"
                            data-vv-as="Swift"
                            v-model="bankAccountBean.swift_code"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            oninput="value=value.slice(0, 11)" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" :class="{'required-item': !isView}" for="swift_code">Swift：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('swift_code')"
                            class="help text-danger">{{ errors.first('swift_code') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right"
                      :class="{'has-error': errors.has('address'), 'valid': isFormFieldValid('address')}">
                  <div class="input-group">
                    <input name="address"
                            data-vv-as="Bank Address"
                            v-model="bankAccountBean.address"
                            autocomplete="off"
                            maxlength="70"
                            v-validate="'required|validBankAddress'"
                            required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" :class="{'required-item': !isView}" for="address">Bank Address：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('address')"
                            class="help text-danger">{{ errors.first('address') }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right">
                  <div class="input-group">
                    <input
                      name="iban"
                      data-vv-as="IBAN"
                      v-model="bankAccountBean.iban"
                      autocomplete="off"
                      oninput="value=value.slice(0, 34)"
                    />
                    <label class="control-label" for="iban">IBAN：</label>
                    <i class="bar"></i>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </vuestic-modal>

    <vuestic-modal show.sync="true"
                    ref="showTips"
                    :okText="'modal.confirm2' | translate"
                    :okClass="'btn btn-primary btn-micro'"
                    :cancelClass="'btn btn-secondary btn-micro'"
                    :cancelText="'modal.cancel2' | translate"
                    class="show-detail">
      <div slot="title">{{ $t("tips") }}</div>
      <!-- <div slot="title">{{'modal.refundReason' | translate}}</div> -->
      <div class="text-center">
        You submitted your account for a review, once it's been approved you will be able to use this account for a withdrawal
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-secondary" style="padding: 0.5rem 2rem;" @click="handleClose">{{ $t("modal.close") }}</button>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import { request } from '@/utils/utils.js'
import store from '@/store'

export default {
  name: 'BankAccountCreate',
  data () {
    this.$validator.extend('validEmail', {
      validate: (value, ref) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(value))
      },
      getMessage: (field) => 'The Email Field must be a valid ' + field + '.'
    })
    return {
      isFormShow: true,
      bankAccountShow: true,
      bankAccountBean: {
        info_country: '',
        info_name: '',
        info_address: '',
        info_email: '',
        info_registration_number: '',
        account_number: '',
        currency: '',
        account_name: '',
        bank_name: '',
        country: '',
        branch: '',
        swift_code: '',
        address: '',
        iban: '',
      },
      infoCountryStatus: false,
      countryStatus: false,
      currencyStatus: false,
      isView: false
    }
  },
  computed: {
    infoCountryOption () {
      if (store.state.datasource.basicRegions.regions) {
        return store.state.datasource.basicRegions.regions.map(region => {
          return { label: region.name, value: region.code }
        })
      }
      return []
    },
    countryOption () {
      if (store.state.datasource.basicRegions.regions) {
        return store.state.datasource.basicRegions.regions.map(region => {
          return { label: region.name, value: region.code }
        })
      }
      return []
    },
    currencyOption () {
      if (store.state.datasource.basicRegions.currencies) {
        return store.state.datasource.basicRegions.currencies.map(currency => {
          return { label: currency, value: currency }
        })
      }
      // return [
      //   { label: 'USD', value: 'USD' },
      //   { label: 'EUR', value: 'EUR' }
      // ]
    }
  },
  created () {
  },
  mounted () {
    const refsArray = ['infoCountryRefs', 'countryRefs', 'currencyRefs']
    refsArray.forEach(value => {
      if (this.$refs[value]) {
        this.$refs[value].$el.getElementsByTagName('input')[0].autocomplete = 'off'
      }
    })
    store.dispatch('datasource/GetBasicRegions')

    this.$validator.extend('validBankAddress', {
      validate: (value) => {
        const val = value
          .replace(/[\u200B-\u200D\uFEFF]/g, '')
          .trim()

        // 长度限制
        if (!val || val.length > 70) {
          return false
        }

        // 仅允许数字、字母、空格
        return /^[A-Za-z0-9 ]+$/.test(val)
      },
      getMessage: () => {
        return 'Bank Address can only contain letters, numbers and spaces, max 70 characters.'
      }
    })
  },
  methods: {
    resetForm () {
      this.bankAccountBean = {
        info_country: '',
        info_name: '',
        info_address: '',
        info_email: '',
        info_registration_number: '',
        account_number: '',
        currency: '',
        account_name: '',
        bank_name: '',
        country: '',
        branch: '',
        swift_code: '',
        address: '',
        iban: '',
      }
      const statusArray = ['infoCountryStatus', 'countryStatus', 'currencyStatus']
      statusArray.forEach(value => this[value] = false)
    },
    cleanText (value = '') {
      return value
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim()
    },
    async createBankAccount () {
      const that = this
      that.loadingFullScreen('createBankAccountLoading', 'loading', 'fa fa-hourglass-half')
      const access_token = localStorage.getItem('Authorization')
      const bankParams = {
        account_number: that.cleanText(that.bankAccountBean.account_number),
        account_name: that.cleanText(that.bankAccountBean.account_name),
        bank_name: that.cleanText(that.bankAccountBean.bank_name),
        branch: that.cleanText(that.bankAccountBean.branch),
        swift_code: that.cleanText(that.bankAccountBean.swift_code),
        address: that.cleanText(that.bankAccountBean.address),
        iban: that.cleanText(that.bankAccountBean.iban),
        currency: that.bankAccountBean.currency.value,
        country: that.bankAccountBean.country.value,
      }
      let params = { ...bankParams }
      // console.log('params -> ', params)
      request({
        method: 'post',
        url: `api/dashboard/merchant/assets/bank-account/create?access_token=${access_token}`,
        data: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        that.createBankAccountLoading.close()
        let data = res.data
        if (data.code === '10000') {
          that.resetForm()
          that.$message({
            type: 'success',
            duration: 5000,
            message: data.msg
          })
          that.$refs.bankAccountModal.close()
          that.$refs.showTips.open()
          that.$emit('close')
        } else {
          that.$message({
            type: 'error',
            duration: 5000,
            message: data.msg
          })
        }
      }).catch(err => { })
    },
    renderForm () {
      if (!this.bankDetail.id) {
        this.isView = false
        this.resetForm()
      } else {
        this.isView = true
        this.bankAccountBean.account_number = this.bankDetail.account_number
        this.bankAccountBean.currency = this.currencyOption.filter(currency => currency.value === this.bankDetail.currency)[0]
        this.bankAccountBean.account_name = this.bankDetail.account_name
        this.bankAccountBean.bank_name = this.bankDetail.bank_name
        this.bankAccountBean.country = this.countryOption.filter(country => country.value === this.bankDetail.country)[0]
        this.bankAccountBean.branch = this.bankDetail.branch
        this.bankAccountBean.swift_code = this.bankDetail.swift_code
        this.bankAccountBean.address = this.bankDetail.address
        this.bankAccountBean.iban = this.bankDetail.iban
      }
    },
    init () {
      this.$refs.bankAccountModal.open()
      this.$validator.reset()
      this.resetForm()

      this.$nextTick(() => { this.renderForm() })

      const that = this
      that.$refs.bankAccountModal.ok = () => {
        that.$validator.validateAll().then(async result => {
          if (!that.bankAccountBean.country) {
            that.countryStatus = true
          } else {
            that.countryStatus = false
          }
          if (!that.bankAccountBean.currency) {
            that.currencyStatus = true
          } else {
            that.currencyStatus = false
          }
          if (!that.countryStatus && !that.currencyStatus && result) {
            await that.createBankAccount()
          }
        })
      }
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    fieldChange (val, refsValue, status) {
      if (!val) {
        this.$refs[refsValue].$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this[status] = true
      } else {
        this[status] = false
      }
    },
    loadingFullScreen (controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    handleClose () {
      this.$refs.showTips.close()
    }
  },
  props: {
    bankDetail: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
.bank-account {
  h3 {
    margin: 0;
  }
  .form-group {
    margin-bottom: 0;
  }
  #typeSelect .scrollbar-wrapper,
  #infoCountrySelect .scrollbar-wrapper,
  #countrySelect .scrollbar-wrapper,
  #currencySelect .scrollbar-wrapper {
    max-height: 200px !important;
  }
  #typeSelect.required-item,
  #infoCountrySelect.required-item,
  #countrySelect.required-item,
  #currencySelect.required-item {
    label.control-label {
      &::before {
        content: "*";
        color: red;
        font-size: 12px;
      }
    }
  }

  fieldset[disabled="disabled"] {
    .control-label {
      font-size: 0.6rem;
      color: #4ae387;
      font-weight: 600;
      text-transform: uppercase;
      top: -0.6rem;
      left: 0;
    }
    .vuestic-simple-select__unselect {
      display: none;
    }
  }
  input[disabled="disabled"] ~ label.control-label {
    font-size: 0.6rem;
    color: #4ae387;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
  }

  .select-group.dropdown-arrow {
    .vuestic-simple-select__dropdown-arrow {
      display: none;
    }
  }

  .input-group {
    .required-item {
      &::before {
        content: "*";
        color: red;
        font-size: 12px;
      }
    }
  }

  .with-icon-right {
    margin: 0;
  }
}
</style>
